import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { DatePipe, DecimalPipe, registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { NZ_I18N, en_US } from 'ng-zorro-antd/i18n';
import { NzIconModule } from 'ng-zorro-antd/icon';
import * as AllIcons from '@ant-design/icons-angular/icons';
import { IconDefinition } from '@ant-design/icons-angular';
import { AuthGuard, ModalService, OutGuard } from './shared';
import { AuthService } from './shared/services/auth.service';
import { BaseService } from './shared/services/base.services';
import { HttpInterceptService } from './shared/services/http-interceptor.service';
import { StorageService } from './shared/services/storage.services';
import { UserSettingsService } from './shared/services/user-setting.service';
import { Setting } from './shared/setting';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { agentsEngineInterceptor } from './features/agents-engine/agents-engine.interceptor';

import { SharedModule } from './shared/shared.module';
import { RouterModule } from '@angular/router';

const antDesignIcons = Object.values(AllIcons) as IconDefinition[];

registerLocaleData(en);

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    OverlayModule,
    NzIconModule.forRoot(antDesignIcons),
    SharedModule,
    FormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    BrowserAnimationsModule,
  ],
  providers: [
    AuthGuard,
    OutGuard,
    HttpInterceptService,
    DatePipe,
    DecimalPipe,
    ModalService,
    AuthService,
    UserSettingsService,
    StorageService,
    BaseService,
    Setting,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptService, multi: true },
    { provide: NZ_I18N, useValue: en_US },
    // El interceptor funcional de «Agentes IA» solo actúa sobre `${APIEndPoint}/agents-engine/*`; los
    // interceptores de clase (`AuthInterceptor`, `HttpInterceptService`) siguen corriendo para toda petición.
    provideHttpClient(withInterceptors([agentsEngineInterceptor]), withInterceptorsFromDi()),
  ],
})
export class AppModule {}
